export class EventListenerManager {
    constructor() {
        this._listenerMap = new Map, this._eventListenerTransformer = event => event;
    }
    setEventListenerTransformer(transformer) {
        this._eventListenerTransformer = transformer || (event => event);
    }
    addEventListener(type, listener, options) {
        if (!listener) return;
        const capture = this._resolveCapture(options), once = this._resolveOnce(options), listenerTypeMap = this._getOrCreateListenerTypeMap(type), wrappedMap = this._getOrCreateWrappedMap(listenerTypeMap, listener);
        if (wrappedMap.has(capture)) return;
        const wrappedListener = event => {
            const transformedEvent = this._eventListenerTransformer(event);
            "function" == typeof listener ? listener(transformedEvent) : listener.handleEvent && listener.handleEvent(transformedEvent), 
            once && this._deleteListenerRecord(type, listener, capture);
        };
        wrappedMap.set(capture, {
            wrappedListener: wrappedListener,
            options: options
        }), this._nativeAddEventListener(type, wrappedListener, options);
    }
    removeEventListener(type, listener, options) {
        var _a, _b;
        if (!listener) return;
        const capture = this._resolveCapture(options), wrappedRecord = null === (_b = null === (_a = this._listenerMap.get(type)) || void 0 === _a ? void 0 : _a.get(listener)) || void 0 === _b ? void 0 : _b.get(capture);
        wrappedRecord && (this._nativeRemoveEventListener(type, wrappedRecord.wrappedListener, capture), 
        this._deleteListenerRecord(type, listener, capture));
    }
    dispatchEvent(event) {
        return this._nativeDispatchEvent(event);
    }
    clearAllEventListeners() {
        this._listenerMap.forEach(((listenerMap, type) => {
            listenerMap.forEach((wrappedMap => {
                wrappedMap.forEach(((wrappedRecord, capture) => {
                    this._nativeRemoveEventListener(type, wrappedRecord.wrappedListener, capture);
                }));
            }));
        })), this._listenerMap.clear();
    }
    _resolveCapture(options) {
        return "boolean" == typeof options ? options : !!(null == options ? void 0 : options.capture);
    }
    _resolveOnce(options) {
        return "object" == typeof options && !!(null == options ? void 0 : options.once);
    }
    _getOrCreateListenerTypeMap(type) {
        let listenerTypeMap = this._listenerMap.get(type);
        return listenerTypeMap || (listenerTypeMap = new Map, this._listenerMap.set(type, listenerTypeMap)), 
        listenerTypeMap;
    }
    _getOrCreateWrappedMap(listenerTypeMap, listener) {
        let wrappedMap = listenerTypeMap.get(listener);
        return wrappedMap || (wrappedMap = new Map, listenerTypeMap.set(listener, wrappedMap)), 
        wrappedMap;
    }
    _deleteListenerRecord(type, listener, capture) {
        const listenerTypeMap = this._listenerMap.get(type);
        if (!listenerTypeMap) return;
        const wrappedMap = listenerTypeMap.get(listener);
        wrappedMap && (wrappedMap.delete(capture), 0 === wrappedMap.size && listenerTypeMap.delete(listener), 
        0 === listenerTypeMap.size && this._listenerMap.delete(type));
    }
    _nativeAddEventListener(type, listener, options) {
        throw new Error("_nativeAddEventListener must be implemented by derived classes");
    }
    _nativeRemoveEventListener(type, listener, options) {
        throw new Error("_nativeRemoveEventListener must be implemented by derived classes");
    }
    _nativeDispatchEvent(event) {
        throw new Error("_nativeDispatchEvent must be implemented by derived classes");
    }
}
//# sourceMappingURL=event-listener-manager.js.map